module.exports = __webpack_public_path__ + "static/media/HCMM112.9b7263f3.jpg";